import Lottie from 'lottie-react';
import { useTranslation } from 'react-i18next';

import LoadingAnimation from '../../images/lotties/CTA-cart.json';

type Props = {
  customTextColor?: string;
  customBgColor?: string;
};

export const LoadingCart = ({ customTextColor, customBgColor }: Props) => {
  const { t } = useTranslation();

  return (
    <div
      className={`flex flex-col items-center justify-center ${
        customBgColor ? customBgColor : 'bg-primary-dark'
      }`}
    >
      <Lottie
        animationData={LoadingAnimation}
        style={{ width: '100%', maxWidth: '400px', height: 'auto' }}
      />
      <span
        className={`animate-pulse font-primary text-3xl font-extrabold ${
          customTextColor ? customTextColor : 'text-white'
        }`}
      >
        {t('common.loading')}
      </span>
    </div>
  );
};
